// Contact for privacy, legal and account-deletion requests. Shown on the
// Terms and Privacy pages and in the site footer — change it here only.
export const LEGAL_CONTACT = "jaletrailers@gmail.com";
